import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';

import { NodeHotKey } from 'libs/editor/plugins/helpers/nodeHotKey';
import { RenderNode } from 'libs/editor/plugins/helpers/renderNode';

const UnorderedListNode = observer(({ attributes, children }) => (
  <UL {...attributes}>{children}</UL>
));

const type = 'unordered_list';

export function UnorderedList(listPlugin) {
  const active = value =>
    listPlugin.utils.isSelectionInList(value) &&
    listPlugin.utils.getCurrentList(value).type === type;
  return {
    button: {
      elementType: 'node',
      type,
      active,
      handleClick: store => {
        const { value, reference, onChange } = store;
        if (active(value)) {
          listPlugin.changes.unwrapList(reference, type);
        } else {
          listPlugin.changes.wrapInList(reference, type);
        }
        onChange(reference);
      },
    },
    plugins: [
      NodeHotKey({ key: '*', type }),
      RenderNode(type, props => <UnorderedListNode {...props} />),
      listPlugin,
    ],
  };
}

const UL = styled.ul`
  margin-top: ${props => props.theme.spacing.default};
  padding-left: ${props => props.theme.spacing.large};
  list-style: disc;
`;
